// Lazy load function
const lazyLoad = (file) => () =>
  import(
    /* webpackChunkName: "[request]" */ `@/views/demand-planning/crop-tracker/${file}.vue`
  );

export default [
  {
    path: "/crop-tracker",
    name: "crop-tracker-list",
    meta: { requiresAuth: true, applicationFeatureCode: "CropTracker" },
    components: {
      content: lazyLoad("crop-tracker-list"),
    },
  },
  {
    path: "/crop-tracker/create",
    name: "crop-tracker-create",
    meta: { requiresAuth: true, applicationFeatureCode: "CropTracker" },
    components: {
      content: lazyLoad("crop-tracker"),
    },
  },

  {
    path: "/crop-tracker/review/:id",
    name: "crop-tracker-review",
    meta: { requiresAuth: true, applicationFeatureCode: "CropTracker" },
    components: {
      content: lazyLoad("crop-tracker"),
    },
  },

  // Outstanding Sales Forcast Detail - Grid Report
  {
    path: "/mrp-outstanding-sales-forcast",
    name: "mrp-outstanding-sales-forcast",
    meta: { requiresAuth: true, applicationFeatureCode: "CropTracker" },
    components: {
      content: lazyLoad("outstanding-sales-forcast"),
    },
  },
  // Crop Tracker Carry In Detail - Grid Report
  {
    path: "/crop-tracker-carry-in-detail",
    name: "crop-tracker-carry-in-detail",
    meta: { requiresAuth: true, applicationFeatureCode: "CropTracker" },
    components: {
      content: lazyLoad("carry-in-detail-report"),
    },
  },
  // Crop Tracker On Hand Detail - Grid Report
  {
    path: "/crop-tracker-on-hand-detail",
    name: "crop-tracker-on-hand-detail",
    meta: { requiresAuth: true, applicationFeatureCode: "CropTracker" },
    components: {
      content: lazyLoad("onhand-detail-report"),
    },
  },

  // mrp-outstanding-sales-order-detail
  // This get triggered from Crop Tracker Module (SD)
  {
    path: "/mrp-outstanding-sales-order-detail",
    name: "mrp-outstanding-sales-order-detail",
    meta: { requiresAuth: true, applicationFeatureCode: "CropTracker" },
    components: {
      content: lazyLoad("mrp-outstanding-sales-order-detail"),
    },
  },

  // mrp-contract-detail
  // This get triggered from Crop Tracker Module (SD)
  {
    path: "/mrp-contract-detail",
    name: "mrp-contract-detail",
    meta: { requiresAuth: true, applicationFeatureCode: "CropTracker" },
    components: {
      content: lazyLoad("mrp-contract-detail"),
    },
  },
];
